import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ParametroFrota } from 'projects/eddydata-lib/src/lib/entidade/frota/parametro-frota.model';
import { BaseResourceService } from 'projects/eddydata-lib/src/lib/models/services/base-resource.service';

@Injectable({
  providedIn: 'root'
})
export class ParametroFrotaService extends BaseResourceService<ParametroFrota> {

  constructor(
    protected injector: Injector
  ) {
    super(`parametros-frota`, injector);
  }

  public obterParametro(orgao: number): Observable<ParametroFrota> {
    return this.http.get<ParametroFrota>(
      `${this.login.cidade.id}/${this.api}/obter/${orgao}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }
}
